import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Table, Tooltip, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import Utils from '@/components/Utils';
import config from '@/config/config';

export default class CommonApplicationsTable extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { sortedInfo: null };
  }

  handleFilterChange(pagination, filters, sorter) {
    this.setState({ sortedInfo: sorter });
  }

  getTableRowProps(record) {
    return {
      onClick: () => this.props.app.urlManager.pushPage(config.ApplicationRoutes.userDashboard, {}, record.userID),
    };
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: 'Name',
        dataIndex: 'fullName',
        key: 'fullName',
        sorter: (a, b) => (a.fullName || '').localeCompare(b.fullName || ''),
        sortOrder: sortedInfo.columnKey === 'fullName' && sortedInfo.order,
      },
      {
        title: 'Application State',
        dataIndex: 'applicationState',
        key: 'applicationState',
        sorter: (a, b) => (a.applicationState || '').localeCompare(b.applicationState || ''),
        sortOrder: sortedInfo.columnKey === 'applicationState' && sortedInfo.order,
      },
      {
        title: 'Type',
        dataIndex: 'applicationType',
        key: 'applicationType',
        sorter: (a, b) => (a.applicationType || '').localeCompare(b.applicationType || ''),
        sortOrder: sortedInfo.columnKey === 'applicationType' && sortedInfo.order,
      },
      {
        title: 'Created',
        dataIndex: 'applicationCreatedOn',
        key: 'applicationCreatedOn',
        render: (applicationCreatedOn) =>
          applicationCreatedOn ? Utils.getDateOnUIFormatByTimestamp(applicationCreatedOn) : '',
        sorter: (a, b) => a.applicationCreatedOn - b.applicationCreatedOn,
        sortOrder: sortedInfo.columnKey === 'applicationCreatedOn' && sortedInfo.order,
      },
      {
        title: 'Submitted',
        dataIndex: 'applicationSubmittedOn',
        key: 'applicationSubmittedOn',
        render: (applicationSubmittedOn) =>
          applicationSubmittedOn ? Utils.getDateOnUIFormatByTimestamp(applicationSubmittedOn) : '',
        sorter: (a, b) => a.applicationSubmittedOn - b.applicationSubmittedOn,
        sortOrder: sortedInfo.columnKey === 'applicationSubmittedOn' && sortedInfo.order,
      },
      {
        title: 'Reviewed',
        dataIndex: 'applicationReviewedOn',
        key: 'applicationReviewedOn',
        render: (applicationReviewedOn) =>
          applicationReviewedOn ? Utils.getDateOnUIFormatByTimestamp(applicationReviewedOn) : '',
        sorter: (a, b) => a.applicationReviewedOn - b.applicationReviewedOn,
        sortOrder: sortedInfo.columnKey === 'applicationReviewedOn' && sortedInfo.order,
      },
    ];

    console.log('*************** common app table will return table', this.props.data);
    return (
      <Table
        columns={columns}
        dataSource={this.props.data.map((item) => ({
          id: item.id,
          fullName: item.user.firstName + ' ' + item.user.lastName,
          applicationState: item.state || '-',
          applicationType: item.type || '-',
          applicationCreatedOn: item.createdOn,
          applicationSubmittedOn: item.submittedOn || null,
          applicationReviewedOn: item.reviewedOn || null,
          userID: item.user.id,
        }))}
        rowKey="id"
        loading={this.props.isLoading}
        onChange={this.handleFilterChange}
        onRow={this.getTableRowProps}
        pagination={{ pageSize: 10, hideOnSinglePage: true, showSizeChanger: false, position: ['bottomCenter'] }}
        locale={{ emptyText: 'No data found!' }}
      />
    );
  }
}
